function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './TimelineNavigationCompact.css';
import React from 'react';
// import { get, JssField, injectImageResolution, pathJoin, getMediaHost, getDictionaryItem, DictionaryProps, } from '../../utils';
import { get, getDictionaryItem } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { tealiumClickFunc, tealiumMergeClickData } from "../../utils/tealium";
export var TimelineNavigationCompact = function TimelineNavigationCompact(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var activeItemId = get(fields, 'data.item.activeItemId');
  var daysNavAnalytics = get(fields, 'data.daysNavAnalytics');
  var values = get(fields, 'data.item.days.values');
  var dictionary = get(fields, 'data.dictionary');
  var day = getDictionaryItem(dictionary, 'Day');
  var renderItems = function renderItems() {
    if (values) {
      var newValue = values;
      /* if (rtl) {
        newValue = values.slice(0).reverse();
      } */
      var notRouterLinksCondProps = {
        tabIndex: -1
      };
      return newValue.map(function (item, index) {
        var id = get(item, 'id');
        var url = get(item, 'url');
        return /*#__PURE__*/React.createElement("a", _extends({
          key: index,
          "data-id": id,
          className: "timeline-event-navigation__list ".concat(activeItemId === id ? 'timeline-event-navigation__list--active' : ''),
          href: url,
          "aria-label": "Days",
          onClick: function onClick() {
            return tealiumClickFunc(tealiumMergeClickData(daysNavAnalytics, params), item.name);
          }
        }, notRouterLinksCondProps), day.replace('{day}', "".concat(index + 1)));
      });
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-event-navigation-wrapper"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      state = _ref2.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "timeline-event-navigation__arrow-left"
    }, renderPreviousButton()), /*#__PURE__*/React.createElement("div", {
      className: "timeline-event-navigation ".concat(get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'timeline-event-navigation-center' : '')
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1441
          },
          items: 7
        },
        tabletLarge: {
          breakpoint: {
            max: 1440,
            min: 769
          },
          items: 7
        },
        tabletMedium: {
          breakpoint: {
            max: 768,
            min: 600
          },
          items: 6
        },
        tablet: {
          breakpoint: {
            max: 599,
            min: 480
          },
          items: 5
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 4
        }
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "timeline-event-navigation__arrow-right"
    }, renderNextButton()));
  }))))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(commonStylesFocus, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(rtl ? rtlSpecific : ltrSpecific, " "),
    componentTabIndex: "disabled"
  }, children);
};
export var commonStyles = "c98aymt";
export var ltrStyles = "lrvj5x7";
export var rtlStyles = "r1nwy4bz";
var commonStylesFocus = "cqpofpk";
var ltrSpecific = "l2mhmi";
var rtlSpecific = "rjqo6wu";
export default TimelineNavigationCompact;